/**
 * @generated SignedSource<<abc88030ca600ab5f8089ec5268cad4b>>
 * @relayHash 4b8bbdc518ab172a87990ef658a35f17
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/447.0.0-2024-01-29T17:50:20.134Z/PdpSharedDutiesMessageQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type PdpSharedDutiesMessageQuery$variables = {
  buyerId?: string | null;
  destinationCountry?: string | null;
  itemId?: string | null;
  shipmentQuoteId?: string | null;
};
export type PdpSharedDutiesMessageQuery$data = {
  readonly viewer: {
    readonly customsDuties: {
      readonly crossCustomsBorder: boolean | null;
      readonly incoterm: string | null;
    } | null;
    readonly newDutiesMsgAndTaxEnabled: boolean | null;
  };
};
export type PdpSharedDutiesMessageQuery = {
  response: PdpSharedDutiesMessageQuery$data;
  variables: PdpSharedDutiesMessageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationCountry"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shipmentQuoteId"
},
v4 = {
  "alias": "newDutiesMsgAndTaxEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "newDutiesMessageAndTax"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"newDutiesMessageAndTax\")"
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "buyerId"
    },
    {
      "kind": "Variable",
      "name": "destinationCountry",
      "variableName": "destinationCountry"
    },
    {
      "kind": "Variable",
      "name": "itemId",
      "variableName": "itemId"
    },
    {
      "kind": "Variable",
      "name": "shipmentQuoteId",
      "variableName": "shipmentQuoteId"
    }
  ],
  "concreteType": "CustomsDuties",
  "kind": "LinkedField",
  "name": "customsDuties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "crossCustomsBorder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incoterm",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedDutiesMessageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PdpSharedDutiesMessageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/447.0.0-2024-01-29T17:50:20.134Z/PdpSharedDutiesMessageQuery",
    "metadata": {},
    "name": "PdpSharedDutiesMessageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bb954b5e351d60ccb22a3e573f78d6aa";

export default node;
